import { Link } from 'react-router-dom';
import { latestNews } from '@/mocks/home';

export default function NewsSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-12 md:mb-16">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              最新资讯
            </span>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
              世界杯前沿动态
            </h2>
          </div>
          <Link
            to="/category/all"
            className="mt-3 sm:mt-0 inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            全部资讯
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestNews.map((news, index) => (
            <Link
              key={news.id}
              to={`/article/${news.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300/50 cursor-pointer"
            >
              <div className="relative overflow-hidden h-48">
                <img
                  src={news.imageUrl}
                  alt={news.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading={index < 3 ? 'eager' : 'lazy'}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 rounded-full text-xs font-semibold">
                    {news.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {news.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {news.summary}
                </p>
                <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-time-line text-xs"></i>
                  </span>
                  {news.date}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}